"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _clsx = _interopRequireDefault(require("clsx"));

var _feefoReviews = _interopRequireDefault(require("./feefo-reviews.css"));

var FeefoReviews = function FeefoReviews(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/_react["default"].createElement("div", {
    id: "feefo-product-review-widgetId",
    className: (0, _clsx["default"])(_feefoReviews["default"].reviewsContainer, 'feefo-review-widget-product'),
    "data-product-sku": data.productSkuId
  });
};

FeefoReviews.resourceType = function () {
  return 'FeefoReviews_1_0_0';
};

FeefoReviews.displayName = 'FeefoReviews';
var _default = FeefoReviews;
exports["default"] = _default;